import { NavLink, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import HeaderUserActions from './HeaderUserActions';

function Icon({ name }) {
  const common = { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', 'aria-hidden': true };
  const s = {
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  };
  switch (name) {
    case 'dashboard':
      return (
        <svg {...common}>
          <path d="M4 13h8V4H4v9Zm0 7h8v-5H4v5Zm10 0h6V11h-6v9Zm0-16v5h6V4h-6Z" fill="currentColor" opacity="0.95" />
        </svg>
      );
    case 'customers':
      return (
        <svg {...common}>
          {/* Building/store (clear at 18px) */}
          <path d="M4 10V6l8-3 8 3v4" {...s} />
          <path d="M6 10v10M10 10v10M14 10v10M18 10v10" {...s} />
          <path d="M3 20h18" {...s} />
        </svg>
      );
    case 'employees':
      return (
        <svg {...common}>
          <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Z" stroke="currentColor" strokeWidth="2"/>
          <path d="M4 20c0-4.42 3.58-8 8-8s8 3.58 8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    case 'clauses':
      return (
        <svg {...common}>
          <path d="M7 3h10l3 3v15a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="2"/>
          <path d="M17 3v4h4" stroke="currentColor" strokeWidth="2"/>
          <path d="M8 12h8M8 16h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    case 'keyfields':
      return (
        <svg {...common}>
          <path d="M14 10a4 4 0 1 0-4 4" stroke="currentColor" strokeWidth="2"/>
          <path d="M14 14 21 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M18.5 18.5 16 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    case 'msa':
      return (
        <svg {...common}>
          <path d="M7 3h7l3 3v15a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="2"/>
          <path d="M14 3v4h4" stroke="currentColor" strokeWidth="2"/>
          <path d="M8 12h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M8 16h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    case 'sow':
      return (
        <svg {...common}>
          <path d="M6 2h12v20l-3-2-3 2-3-2-3 2V2Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
          <path d="M9 8h6M9 12h6M9 16h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    case 'engagements':
      return (
        <svg {...common}>
          <path d="M12 2 2 7l10 5 10-5-10-5Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
          <path d="M2 17l10 5 10-5" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
          <path d="M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
        </svg>
      );
    case 'billing':
      return (
        <svg {...common}>
          <path d="M6 2h12v20l-3-2-3 2-3-2-3 2V2Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
          <path d="M9 7h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M9 12h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M9 17h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    case 'timesheets':
      return (
        <svg {...common}>
          <path d="M8 3h8M9 3V1m6 2V1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M5 5h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="2"/>
          <path d="M7 10h10M7 14h7M7 18h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    case 'approvals':
      return (
        <svg {...common}>
          <path d="M9 11 11 13 15 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" stroke="currentColor" strokeWidth="2"/>
        </svg>
      );
    case 'reports':
      return (
        <svg {...common}>
          <path d="M4 19V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M8 17v-6M12 17V7M16 17v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    case 'settings':
      return (
        <svg {...common}>
          {/* Simple gear (reads cleanly at 18px) */}
          <path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" {...s} />
          <path d="M19 12a7 7 0 0 0-.09-1l2.03-1.58-2-3.46-2.46 1a7.2 7.2 0 0 0-1.73-1L14.5 3h-5L9.25 5.96a7.2 7.2 0 0 0-1.73 1l-2.46-1-2 3.46L5.09 11A7 7 0 0 0 5 12c0 .34.03.67.09 1L3.06 14.58l2 3.46 2.46-1c.53.42 1.11.77 1.73 1L9.5 21h5l.25-2.96c.62-.23 1.2-.58 1.73-1l2.46 1 2-3.46L18.91 13c.06-.33.09-.66.09-1Z" {...s} />
        </svg>
      );
    case 'users':
      return (
        <svg {...common}>
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" stroke="currentColor" strokeWidth="2"/>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <path d="M4 12h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
  }
}

function NavItem({ to, end, icon, children }) {
  const label = typeof children === 'string' ? children : '';
  return (
    <NavLink to={to} end={end} title={label}>
      <span className="nav-icon"><Icon name={icon} /></span>
      <span className="nav-text">{children}</span>
    </NavLink>
  );
}

export default function Layout() {
  const { user, logout, canView, dashboards } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    try {
      const saved = localStorage.getItem('ui.sidebarOpen');
      if (saved === '0') setSidebarOpen(false);
    } catch {
      // ignore
    }
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem('ui.sidebarOpen', sidebarOpen ? '1' : '0');
    } catch {
      // ignore
    }
  }, [sidebarOpen]);

  return (
    <div className={`app-layout ${sidebarOpen ? '' : 'sidebar-closed'}`}>
      <aside className="sidebar" aria-hidden={false}>
        <div
          className="sidebar-brand"
          role="button"
          tabIndex={0}
          onClick={() => setSidebarOpen(o => !o)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') setSidebarOpen(o => !o);
          }}
          aria-expanded={sidebarOpen}
          aria-label={sidebarOpen ? 'Close sidebar' : 'Open sidebar'}
          title={sidebarOpen ? 'Click to collapse sidebar' : 'Click to expand sidebar'}
          style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}
        >
          <img src="/logo.png" alt="Colan" style={{ height: 40, flexShrink: 0 }} />
          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.15 }}>
            <h2 style={{ margin: 0 }}>COLAN INFOTECH</h2>
            <small>Agreement & Invoice ERP</small>
          </div>
        </div>
        <nav className="sidebar-nav">
          <NavItem to="/" end icon="dashboard">Dashboard</NavItem>
          {(canView('customers') || canView('employees')) && <div className="nav-section">Masters</div>}
          {canView('customers') && <NavItem to="/customers" icon="customers">Customers</NavItem>}
          {canView('employees') && <NavItem to="/employees" icon="employees">Employees</NavItem>}
          {canView('clause_library') && <NavItem to="/clauses" icon="clauses">Clause Library</NavItem>}
          {canView('key_fields') && <NavItem to="/key-fields" icon="keyfields">Key Fields</NavItem>}
          <div className="nav-section">Agreements</div>
          {canView('msa') && <NavItem to="/msa" icon="msa">MSA</NavItem>}
          {canView('sow') && <NavItem to="/sow" icon="sow">SOW</NavItem>}
          {canView('engagements') && <NavItem to="/engagements" icon="engagements">Engagement</NavItem>}
          {canView('invoices') && (
            <>
              <div className="nav-section">Billing</div>
              <NavItem to="/invoices" icon="billing">Billing</NavItem>
            </>
          )}
          {canView('timesheets') && <NavItem to="/timesheets" icon="timesheets">Timesheets</NavItem>}
          {canView('approvals') && <NavItem to="/approvals" icon="approvals">Approvals</NavItem>}
          {canView('reports') && (
            <>
              <div className="nav-section">Reports</div>
              <NavItem to="/reports/billed-matrix" icon="reports">Billed Matrix</NavItem>
              <NavItem to="/reports/employee-performance" icon="reports">Employee Performance</NavItem>
            </>
          )}
          {dashboards && dashboards.length > 0 && (
            <>
              <div className="nav-section">Dashboards</div>
              {dashboards.map(d => (
                <NavItem key={d.slug} to={`/dashboards/${d.slug}`} icon="dashboard">{d.name}</NavItem>
              ))}
            </>
          )}
          {(user?.role === 'Admin' || user?.role === 'HR Manager') && (
            <>
              <div className="nav-section">Administration</div>
              {user?.role === 'Admin' && <NavItem to="/users" icon="users">User Management</NavItem>}
              <NavItem to="/settings" icon="settings">Settings</NavItem>
            </>
          )}
        </nav>
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{user?.full_name?.[0]}</div>
            <div>
              <div className="user-name">{user?.full_name}</div>
              <div className="user-role">{user?.role}</div>
            </div>
          </div>
          <button className="btn-logout" onClick={logout}>Sign Out</button>
        </div>
      </aside>
      <main className="main-content">
        <div className="main-content-global-actions">
          <HeaderUserActions />
        </div>
        <Outlet />
      </main>
    </div>
  );
}
